// The view switch's rows: their labels and the design's order (Figma 1047:37201).

/** Which page the workspace shows: the ticket list (one of its views), the automation review or follow-ups. */
export type WorkspaceView = 'tickets' | 'automation' | 'followups';

/** One row of the switch. The ticket list's views are rows of their own. */
export type ViewOption = 'mine' | 'all' | 'automation' | 'unassigned' | 'followups';

export const VIEW_LABELS: Record<ViewOption, string> = {
  mine: 'My tickets',
  all: 'All Kim tickets',
  automation: 'Automation review',
  unassigned: 'Unassigned tickets',
  followups: 'Follow up action',
};

/** The design's order. */
export const VIEW_ORDER: readonly ViewOption[] = ['mine', 'all', 'automation', 'unassigned', 'followups'];

export type ViewCounts = Partial<Record<ViewOption, number>>;
